import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';

@Injectable()
export class HttpHelper {
	configOptionsForPost(){
		let headers = new Headers();
		headers.append('Content-Type','application/x-www-form-urlencoded');
		let options = new RequestOptions({ headers: headers });		

		return options
	}

	configOptionsForPostPayload(){
		let headers = new Headers();
		headers.append('Content-Type','application/json');
		let options = new RequestOptions({ headers: headers });		

		return options
	}	

	configOptionsWithToken(token){
		let headers = new Headers();
		headers.append('Authorization','Bearer ' + token);
		let options = new RequestOptions({ headers: headers });

		return options
	}	
}


// WEBPACK FOOTER //
// ./src/helpers/httpHelper.ts